<script>
import mmenu from "mmenu-js";
import "mmenu-js/dist/mmenu.css";

export default {
    name: "MenuHandler",
    mounted() {
        this.$nextTick(() => {
            const menuElement = document.querySelector("#my-menu");
            if (menuElement) {
                this.menu = new mmenu(menuElement, {
                    extensions: ["pagedim-black", "position-right"],
                    navbar: {
                        title: "Menu"
                    },
                    "offCanvas": {
                        "position": "right-front"
                    },
                    "theme": "dark"
                });
            } else {
                console.error("Menu element not found");
            }
        });
    },
    data() {
        return {
            menu: null
        };
    },
    methods: {
        toggleSearchBar() {
            if (this.menu) {
                if (this.menu.API.opened) {
                    this.menu.close();
                } else {
                    this.menu.open();
                }
            }
        }
    }
}
</script>

<template>
    <div class="">
        <button class="btn-plain h-[--header-depth] m-0 inline-flex flex-center-all w-[22px] text-[22px]"
                id="mmenu-button"
                v-on:click.prevent="toggleSearchBar">
            <span class="ph ph-bold ph-list">
                <span class="sr-only">Toggle search bar</span>
            </span>
        </button>
        <!-- Ensure the #my-menu element is present in the DOM -->
        <nav v-cloak id="my-menu" class="prose">
            <slot></slot>
            <!-- Menu content goes here -->
        </nav>
    </div>
</template>

<style>
/* Add your styles here */

.mm-menu {

}
</style>
